<form
  class="terms-container"
  [formGroup]="form"
  (submit)="accept()"
  *ngIf="!loading"
>
  <div class="flex center logo-container">
    <img class="moyaLogo" src="/assets/moya_logo.svg" />
  </div>
  <p class="title">We've Updated Our Terms and conditions</p>
  <section class="checkbox-container">
    <p>
      <mat-checkbox formControlName="business"
        >I have read and accept the
        <a
          href="https://moya.app/business-portal-terms-conditions/"
          target="_blank"
          ><b>Moya App Business Portal Terms and Conditions</b></a
        ></mat-checkbox
      >
    </p>
    <p>
      <mat-checkbox formControlName="service">
        I have read and accept the
        <a
          href="https://moya.app/service-and-investment-terms-conditions-2/"
          target="_blank"
          (mousedown)="$event.stopPropagation()"
          ><b>Moya App Service and Investment Terms and Conditions</b></a
        ></mat-checkbox
      >
    </p>
  </section>

  <button
    mat-raised-button
    class="blueButton"
    [disabled]="form.invalid"
    appearance="outline"
    type="submit"
  >
    I AGREE
  </button>
</form>

<div class="loader" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
